export const retailSalesConstants = {
    RETAIL_SALES_GET_WINNERS_REQUEST:"RETAIL_SALES_GET_WINNERS_REQUEST",
    RETAIL_SALES_GET_WINNERS_COMPLETE:"RETAIL_SALES_GET_WINNERS_COMPLETE",

    RETAIL_SALES_GET_ACTIVATION_REPORT_REQUEST:"RETAIL_SALES_GET_ACTIVATION_REPORT_REQUEST",
    RETAIL_SALES_GET_ACTIVATION_REPORT_COMPLETE:"RETAIL_SALES_GET_ACTIVATION_REPORT_COMPLETE",

    RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_REQUEST:"RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_REQUEST",
    RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_COMPLETE:"RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_COMPLETE",
    RETAIL_SALES_CLEAR_ACTIVATION_REPORT_EXPORT:"RETAIL_SALES_CLEAR_ACTIVATION_REPORT_EXPORT",

    RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_REQUEST:"RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_REQUEST",
    RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_COMPLETE:"RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_COMPLETE",

    RETAIL_SALES_GET_WINNER_VOUCHERS_REQUEST:"RETAIL_SALES_GET_WINNER_VOUCHERS_REQUEST",
    RETAIL_SALES_GET_WINNER_VOUCHERS_COMPLETE:"RETAIL_SALES_GET_WINNER_VOUCHERS_COMPLETE",

    RETAIL_SALES_RESEND_ACTIVATION_REQUEST:"RETAIL_SALES_RESEND_ACTIVATION_REQUEST",
    RETAIL_SALES_RESEND_ACTIVATION_COMPLETE:"RETAIL_SALES_RESEND_ACTIVATION_COMPLETE",

    RETAIL_SALES_CLEAR_WINNER_VOUCHERS:"RETAIL_SALES_CLEAR_WINNER_VOUCHERS",

    RETAIL_SALES_GET_JOB_TITLES_REQUEST:"RETAIL_SALES_GET_JOB_TITLES_REQUEST",
    RETAIL_SALES_GET_JOB_TITLES_COMPLETE:"RETAIL_SALES_GET_JOB_TITLES_COMPLETE",

    RETAIL_SALES_DELETE_JOB_TITLE_REQUEST:"RETAIL_SALES_DELETE_JOB_TITLE_REQUEST",
    RETAIL_SALES_DELETE_JOB_TITLE_COMPLETE:"RETAIL_SALES_DELETE_JOB_TITLE_COMPLETE",

    RETAIL_SALES_SAVE_JOB_TITLES_REQUEST:"RETAIL_SALES_SAVE_JOB_TITLES_REQUEST",
    RETAIL_SALES_SAVE_JOB_TITLES_COMPLETE:"RETAIL_SALES_SAVE_JOB_TITLES_COMPLETE",
    RETAIL_SALES_CLEAR_SAVE_JOB_TITLES_RESULT:"RETAIL_SALES_CLEAR_SAVE_JOB_TITLES_RESULT",

    RETAIL_SALES_DEALER_LIST_REQUEST:"RETAIL_SALES_DEALER_LIST_REQUEST",
    RETAIL_SALES_DEALER_LIST_COMPLETE:"RETAIL_SALES_DEALER_LIST_COMPLETE",

    RETAIL_SALES_DEALER_LOOKUP_REQUEST:"RETAIL_SALES_DEALER_LOOKUP_REQUEST",
    RETAIL_SALES_DEALER_LOOKUP_COMPLETE:"RETAIL_SALES_DEALER_LOOKUP_COMPLETE",

    RETAIL_SALES_GET_DEALERS_REQUEST:"RETAIL_SALES_GET_DEALERS_REQUEST",
    RETAIL_SALES_GET_DEALERS_COMPLETE:"RETAIL_SALES_GET_DEALERS_COMPLETE",

    RETAIL_SALES_SAVE_DEALERS_REQUEST:"RETAIL_SALES_SAVE_DEALERS_REQUEST",
    RETAIL_SALES_SAVE_DEALERS_COMPLETE:"RETAIL_SALES_SAVE_DEALERS_COMPLETE",
    RETAIL_SALES_CLEAR_SAVE_DEALERS_RESULT:"RETAIL_SALES_CLEAR_SAVE_DEALERS_RESULT",

    RETAIL_SALES_ADD_WINNERS_REQUEST:"RETAIL_SALES_ADD_WINNERS_REQUEST",
    RETAIL_SALES_ADD_WINNERS_COMPLETE:"RETAIL_SALES_ADD_WINNERS_COMPLETE",
    RETAIL_SALES_CLEAR_ADD_WINNERS_RESULT:"RETAIL_SALES_CLEAR_ADD_WINNERS_RESULT",

    RETAIL_SALES_UPDATE_WINNER_REQUEST:"RETAIL_SALES_UPDATE_WINNER_REQUEST",
    RETAIL_SALES_UPDATE_WINNER_COMPLETE:"RETAIL_SALES_UPDATE_WINNER_COMPLETE",
    RETAIL_SALES_CLEAR_UPDATE_WINNER_RESULT:"RETAIL_SALES_CLEAR_UPDATE_WINNER_RESULT",

    // The reward is entered in points and defaults to 5000 (= GBP 50 at 100 points = GBP 1).
    // The backend takes the GBP value, so points are divided by this ratio before sending.
    RETAIL_SALES_DEFAULT_REWARD_POINTS:5000,
    RETAIL_SALES_POINTS_PER_GBP:100,

    RETAIL_SALES_APPLICATION_EQUIPE_ID:1,
}
